import { render, staticRenderFns } from "./IssuesUpdateModal.vue?vue&type=template&id=1387f2ea&scoped=true"
import script from "./IssuesUpdateModal.vue?vue&type=script&lang=js"
export * from "./IssuesUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./IssuesUpdateModal.vue?vue&type=style&index=0&id=1387f2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387f2ea",
  null
  
)

export default component.exports